var TipoUsuario;
(function (TipoUsuario) {
    TipoUsuario[TipoUsuario["ADMIN"] = 0] = "ADMIN";
    TipoUsuario[TipoUsuario["USUARIO_COM_VINCULO"] = 1] = "USUARIO_COM_VINCULO";
    TipoUsuario[TipoUsuario["USUARIO_SEM_VINCULO"] = 2] = "USUARIO_SEM_VINCULO";
})(TipoUsuario || (TipoUsuario = {}));
export default TipoUsuario;
